module.exports = __webpack_public_path__ + "static/img/memberJb.5748e069.png";